"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsTags = getAnalyticsTags;
exports.getAnalyticsUserToken = getAnalyticsUserToken;
exports.getUserTypeTag = getUserTypeTag;

var _logger = require("@insided/shared/services/logger");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

/**
 * Get the analytics user token for Algolia.
 * For logged-in users: returns `user_<userid>` (non-PII)
 * For guests: returns undefined (uses Algolia's default IP-based tracking)
 *
 * @see https://www.algolia.com/doc/guides/search-analytics/guides/usertoken/
 */
function getAnalyticsUserToken() {
  try {
    var user = (0, _insidedDataStorage.getInsidedData)('user');

    if (user !== null && user !== void 0 && user.userid) {
      var userToken = "user-".concat(user.userid); // eslint-disable-next-line no-console

      console.log('[Algolia Analytics] getAnalyticsUserToken - userToken:', userToken);
      return userToken;
    }
  } catch (error) {
    // getInsidedData throws if not in browser or not initialized
    _logger.logger.error(error, {
      component: 'analytics',
      action: 'getAnalyticsUserToken'
    });
  } // eslint-disable-next-line no-console


  console.log('[Algolia Analytics] getAnalyticsUserToken - guest user, userToken: undefined');
  return undefined;
}
/**
 * Get the user type analytics tag.
 * Returns 'destination-authenticated' for logged-in users,
 * 'destination-guest' for guests.
 */


function getUserTypeTag() {
  try {
    var user = (0, _insidedDataStorage.getInsidedData)('user');

    if (user !== null && user !== void 0 && user.userid) {
      return 'destination-authenticated';
    }
  } catch (error) {
    // getInsidedData throws if not in browser or not initialized
    _logger.logger.error(error, {
      component: 'analytics',
      action: 'getUserTypeTag'
    });
  }

  return 'destination-guest';
}
/**
 * Build analytics tags array with user type tag.
 * @param searchType - 'instant-search' for full page search, 'live' for live search
 */


function getAnalyticsTags(searchType) {
  return [getUserTypeTag(), searchType];
}